import React from 'react';
import PropTypes from 'prop-types';
import { Volume2, VolumeX } from 'lucide-react';
import './VideoSoundButton.css';

const VideoSoundButton = ({ muted, onToggle, className = '' }) => (
  <button
    type="button"
    className={`gm-video-sound-button ${className}`.trim()}
    onClick={onToggle}
    onMouseDown={(event) => event.stopPropagation()}
    onPointerDown={(event) => event.stopPropagation()}
    onTouchStart={(event) => event.stopPropagation()}
    onTouchMove={(event) => event.stopPropagation()}
    aria-label={muted ? 'Ativar som do vídeo' : 'Silenciar vídeo'}
    title={muted ? 'Ativar som' : 'Silenciar'}
  >
    {muted ? <VolumeX size={17} strokeWidth={2.1} /> : <Volume2 size={17} strokeWidth={2.1} />}
  </button>
);

VideoSoundButton.propTypes = {
  muted: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default VideoSoundButton;
